import WeatherForecastSummary from "@/components/weather-forecast-summary/WeatherForecastSummary";
import SearchModal from "@/components/search-modal/SearchModal";

import { useDispatch, useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { findForecastByDateSelected } from "@/helpers/world-forecast-helper";
import { getSingleForecastByDate } from "@/helpers/format-forecast-data-by-date";
import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { useMemo, useState } from "@wordpress/element";
import { LocationType } from "@/types/location-params-type";
import { CityFeature } from "@/schemas/city-schema";

import "./style.scss";

export const App = () => {
	const lang = getCurrentLanguage();
	const { setWorldLocation } = useDispatch(WEATHER_STORE) as WeatherDispatch;
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const [inputValue, setInputValue] = useState<string>("");

	const {
		isLoading,
		forecastData,
		error,
		positionSelected,
		selectedDate,
		cityData,
	} = useSelect((select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
		const store = select(WEATHER_STORE);

		return {
			selectedDate: store.getWorldForecastPrevisionDateState(),
			positionSelected: store.getWorldLocationState(),
			...store.getWorldForecastPrevisionState(),
			...store.getWorldCitiesState(),
		};
	});

	const citiesResult: CityFeature[] = useMemo(() => {
		return cityData
			.filter((item) =>
				lang === "ar"
					? item.properties.ar_label
					: item.properties.en_label

							.toLowerCase()
							.trim()
							.startsWith(inputValue.toLowerCase().trim()),
			)
			.map((item) => {
				return {
					...item,
					properties: {
						...item.properties,
						label: item.properties.en_label,
						id: String(item.properties.id_area),
						name_ar: item.properties.ar_label,
						name_en: item.properties.en_label,
					},
				};
			});
	}, [cityData]);

	const handleSelectLocation = (location: Pick<CityFeature, "properties">) => {
		const {
			properties: { id, label },
		} = location;

		setWorldLocation({
			id,
			name: label,
		});
		setInputValue(label);
		setIsModalOpen(false);
	};

	const forecastUniqueDates = findForecastByDateSelected({
		forecastData,
		selectedDate,
	});

	const dataForWeatherSummary = getSingleForecastByDate({
		forecastData: forecastUniqueDates,
		date: new Date(),
	});

	if (forecastData.length === 0 && !error && !isLoading) {
		return;
	}

	if (positionSelected.id === "") return;

	return (
		<div className="world-forecast-summary">
			<SearchModal
				isOpen={isModalOpen}
				cities={citiesResult}
				showFav={false}
				placeholder="Search world stations"
				closeModal={() => setIsModalOpen(false)}
				locationType={LocationType.WORLD_FORECAST}
				userPosition={null}
				handleSelectLocation={(value: Pick<CityFeature, "properties">) =>
					handleSelectLocation(value)
				}
			/>

			<WeatherForecastSummary
				showFeelLike={false}
				isLoading={isLoading}
				weatherData={{
					ww: dataForWeatherSummary?.ww,
					feelLike: dataForWeatherSummary?.feelLike,
					temperature: dataForWeatherSummary?.temperature_2m,
					timestep: dataForWeatherSummary?.timestep,
				}}
				searchBar={<></>}
			/>
		</div>
	);
};

export default App;
